import { render } from "./loader-empty.vue?vue&type=template&id=5a1977c8&ts=true"
import script from "./loader-empty.vue?vue&type=script&lang=ts"
export * from "./loader-empty.vue?vue&type=script&lang=ts"

import "./loader-empty.vue?vue&type=style&index=0&id=5a1977c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__